export default __webpack_public_path__ + "static/media/new-truck-hover.cf6b4dd6.svg";